import loadImages from '../../libs/loadImages';

import beardman from '../../../images/beardman-walk-5.png';
import beardmanBack from '../../../images/beardman-climb-3.png';
import switchBox from '../../../images/wall-switch-3.png';
import ladder from '../../../images/vertical-ladder-rung.png';
import floorSwitchBox from '../../../images/3-way-switch-rect.png';

const imagesToLoad = {
  beardman,
  beardmanBack,
  switchBox,
  ladder,
  floorSwitchBox,
};

const images = loadImages(imagesToLoad);

export default images;
